import { render, staticRenderFns } from "./NegativeResult.vue?vue&type=template&id=7917ce34"
import script from "./NegativeResult.vue?vue&type=script&lang=js"
export * from "./NegativeResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports